import EventHandler from './dom/event-handler';
import SelectorEngine from './dom/selector-engine';
import Carousel from './carousel';

class CarouselImagegallery {
    /**
     * @param {HTMLElement[]} modals
     */
    constructor (modals) {
        for (const modal of modals) {
            EventHandler.on(modal.parentElement.parentElement, 'show.bs.modal', event => {
                /** @type {Carousel} */
                let gallery = Carousel.getOrCreateInstance(SelectorEngine.findOne(".carousel"));
                gallery.to(event.relatedTarget.dataset.omeImage);
            });
        }
    }
}

EventHandler.one(document, 'DOMContentLoaded', () => {
    new CarouselImagegallery(SelectorEngine.find('.ome-modal-imagegallery'));
});

export default CarouselImagegallery;
